import { createFileRoute } from '@tanstack/react-router'
import { ProjectRoleDefaultsPage } from '@/pages/project-role-defaults'

export const Route = createFileRoute('/_authenticated/staff/defaults')({
  staticData: { title: 'Staff Defaults' },
  component: ProjectRoleDefaultsPage,
})
